"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _customPage = require("@/api/customPage");
var _addBanner = _interopRequireDefault(require("./addBanner.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    addBanner: _addBanner.default
  },
  data: function data() {
    return {
      componentCode: '',
      componentSubcode: '',
      id: '',
      dialogVisible: false,
      popTitle: '',
      title: '',
      status: '',
      options: [{
        label: '上线',
        value: 1
      }, {
        label: '下线',
        value: 0
      }],
      tableData: []
    };
  },
  methods: {
    needRefresh: function needRefresh() {
      // 通知组件刷新（单个组件）
      this.findList();
      this.$emit('refresh', this.id);
    },
    del: function del(val) {
      var _this = this;
      console.log(val);
      //   deleteBanner({
      //     bannerId:val.bannerId
      //   })
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _customPage.deleteBanner)({
          bannerId: val.bannerId
        }).then(function (res) {
          if (res.data) {
            _this.$notify.success({
              title: '温馨提示',
              message: '操作成功'
            });
          }
          _this.findList();
          _this.$emit('refresh', _this.id);
        });
      });
    },
    onClose: function onClose() {
      this.title = '';
      this.status = '';
      this.tableData = [];
      this.dialogVisible = false;
    },
    add: function add() {
      this.$refs.addBanner.open({
        name: '新增',
        type: 'add',
        moduleId: this.id
      });
    },
    detail: function detail(val) {
      this.$refs.addBanner.open({
        name: '编辑',
        type: 'upDate',
        moduleId: this.id,
        bannerId: val.bannerId
      });
    },
    open: function open(data) {
      console.log(data);
      this.popTitle = data.name;
      this.componentSubcode = data.componentSubcode;
      this.componentCode = data.componentCode;
      this.id = data.id;
      this.findList();
      this.dialogVisible = true;
    },
    findList: function findList() {
      var _this2 = this;
      (0, _customPage.moduleDetail)({
        moduleId: this.id,
        bannerName: this.title,
        status: this.status
      }).then(function (res) {
        console.log(res);
        _this2.tableData = res.data.banner;
      });
    },
    clear: function clear() {
      this.title = '';
      this.status = '';
      this.findList();
    },
    search: function search() {
      this.findList();
    }
  }
};